import { fetchAPI } from "../config/api";

export const searchPlayers = (query, signal) =>
  fetchAPI(`/api/search/players?q=${encodeURIComponent(query)}`, { signal });

export const searchTeams = (query, signal) =>
  fetchAPI(`/api/search/teams?q=${encodeURIComponent(query)}`, { signal });
